/**
 * Applications
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageMessageTemplatesComponent,
  AsyncAddMessageTemplateComponent,
  AsyncModifyMessageTemplateComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageMessageTemplatesComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddMessageTemplateComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyMessageTemplateComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
